import React from 'react'
import {connect} from 'react-redux'

import '../../asset/less/component.css'
import '../../asset/less/Showcase.css'

import {
  Alert,
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Input,
  List,
  message,
  Radio,
  Row,
  Skeleton,
  Space,
  Spin,
  Steps
} from 'antd'
import {FileAddOutlined} from '@ant-design/icons'
import {uploadImage} from '../../api/amazonS3'
import Title from 'antd/es/typography/Title'
import {withRouter} from 'react-router'
import {URL_SHOWCASE_HOME} from '../../const'
import {getArtistPermission, patchArtistPermission} from '../../api/artists'
import HttpError from '../../component/base/HttpError'
import BackButton from "../../component/base/BackButton";
import {getArtistShowcaseUrl} from "../../component/Utils";

const {Step} = Steps
const {Panel} = Collapse

@connect((state) => ({
    //decorator, gives component access to the state
    id: state.user.info.id,
    userId: state.user.info.userId,
    email: state.user.info.email,
    artistId: state.user.info.artistId,
    artistName: state.user.info.artistName,
    role: state.user.info.role
}))
class ShowcasePublish extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            is_publish: false,
            current: 0,
            loading: false,
            loadingState: false
        }
    }

    async componentDidMount() {
        if (!this.props.artistId) return
        this.setState({loadingState: true})
        try {
            const permissionRes = await getArtistPermission(this.props.artistId)
            this.setState({
                is_publish: permissionRes.data.is_display
            })
        } catch (e) {
        } finally {
            this.setState({loadingState: false})
        }
    }

    customRequest = (options) => {
        //this occurs on upload, not submit
        const {onError, onSuccess, file, onProgress} = options
        uploadImage(this.props.email, file, onSuccess, onError, onProgress)
    }

    handleCancel = () => {
        //cancelling the modal form for add/edit
        this.setState({
            modalIsVisible: false,
            changedMedia: null
        })
    }

    onSelectPublicChange = (e) => {
        this.setState({
            is_publish: e.target.value
        })
    }

    render() {
        const {current} = this.state

        const next = () => {
            const current = this.state.current + 1
            this.setState({current})
        }

        const prev = () => {
            const current = this.state.current - 1
            this.setState({current})
        }

        const onConnectDomain = () => {
            const hide = message.loading('Action in progress..', 0)
            // Dismiss manually and asynchronously
            setTimeout(hide, 2500)
        }

        let getShowcaseUrl = (name, artist_id) => {
            const baseUrl = 'https://revart.co/showcase/'
            if (name == null) return ''
            name = name.replaceAll(' ', '_').replaceAll('  ', '_').replaceAll('__', '_')
            return baseUrl + artist_id + '_' + name
        }

        const onPublish = async () => {
            try {
                const hide = message.loading('Action in progress..', 0)
                await patchArtistPermission(this.props.artistId, {
                    artist: this.props.artistId,
                    is_display: this.state.is_publish
                })
                setTimeout(hide, 2500)
                if (this.state.is_publish) {
                    setTimeout(() => {
                        window.location.href = getShowcaseUrl(this.props.artistName, this.props.artistId)
                    }, 3000)
                } else {
                    message.success('Your showcase has been designated as private.')
                }
            } catch (e) {
                HttpError(e)
            }
        }

        const stepsTitle = [
            {
                title: 'Preview showcase'
            },
            {
                title: 'Publish settings'
            },
            {
                title: 'Confirm publish'
            }
        ]

        const actionLayout = () => {
            return (
                <div style={{marginTop: 24, display: 'flex', flexDirection: 'row', width: '100%'}}>
                    {current === 0 && (
                        <BackButton {...this.props}/>
                    )}
                    {current > 0 && (
                        <Button
                            style={{
                                marginRight: 'auto'
                            }}
                            onClick={() => prev()}
                        >
                            Previous
                        </Button>
                    )}
                    {current < stepsTitle.length - 1 && (
                        <Button type='primary' onClick={() => next()} style={{marginLeft: 'auto'}}
                                disabled={!this.props.artistId}>
                            Next
                        </Button>
                    )}
                </div>
            )
        }

        const faqs = [
            {
                title: 'Can I use a domain I already have?',
                content: "Yes. You can connect a domain purchased elsewhere by updating your domain settings. We'll walk you through the process."
            },
            {
                title: 'What type of domain can I connect?',
                content:
                    'You can use any domain you purchased (e.g.,  yourname.com) or subdomain (e.g.,  www.yourname.com) with any ending you want.'
            },
            {
                title: 'How long does it take for my website to go live after I connect a domain?',
                content:
                    'Domain updates can take up to 48 hours. When this is finished, visitors from all over the world will be able to see your site. ' +
                    'Your website will be fully connected and protected by an SSL certificate. For more information, please contact our support team (it@revart.co).'
            }
        ]

        const settingsFAQLayout = () => {
            return (
                <List
                    grid={{
                        gutter: 16,
                        column: 2
                    }}
                    dataSource={faqs}
                    renderItem={(item) => (
                        <List.Item>
                            <Card>
                                <Title level={5}>{item.title}</Title>
                                {item.content}
                            </Card>
                        </List.Item>
                    )}
                />
            )
        }

        const stepsPreviewLayout = () => {
            return (
                <Row>
                    <Col style={{paddingTop: 48, marginLeft: 'auto', marginRight: 'auto'}}>
                        <p>See what your site looks like on desktop before you go live</p>
                        <Button
                            icon={<FileAddOutlined/>}
                            size='large'
                            disabled={!this.props.artistId}
                            onClick={(event) => {
                                this.props.history.push({pathname: URL_SHOWCASE_HOME})
                            }}
                            style={{
                                verticalAlign: 'middle',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                width: '100%'
                            }}
                        >
                            Preview
                        </Button>
                        {this.state.is_publish && (
                            <>
                                <Alert style={{
                                    verticalAlign: 'middle',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    width: '100%',
                                    marginTop: 36,
                                    padding: 12,
                                }} message="You showcase is now live" type="success" showIcon/>
                                <Button type={'link'} style={{
                                    verticalAlign: 'middle',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    width: '100%',
                                    textDecoration: 'underline'
                                }} href={getArtistShowcaseUrl(this.props.artistId, this.props.artistName)}
                                        target={'_blank'}>Check it now</Button>
                            </>
                        )}
                        {this.state.loadingState && (
                            <Skeleton/>
                        )}
                        {!this.props.artistId && (
                            <Alert
                                message="Warning"
                                description="No artists were chosen."
                                type="warning"
                                showIcon
                                closable
                            />
                        )}
                    </Col>
                    {actionLayout()}
                </Row>
            )
        }

        const stepsSettingsLayout = () => {
            return (
                <Row>
                    <Col style={{paddingTop: 48, marginLeft: 'auto', marginRight: 'auto'}} span={24}>
                        <Card bordered={false} style={{width: '100%'}}>
                            <div style={{padding: 12}}>
                                <Radio.Group onChange={this.onSelectPublicChange} value={this.state.is_publish}>
                                    <Title level={4}>Who can see your showcase website?</Title>
                                    <Space direction='vertical' style={{marginTop: 12}}>
                                        <Radio value={true}>Shared on RevArt and search engines</Radio>
                                        <Radio value={false}>Only available to you</Radio>
                                    </Space>
                                </Radio.Group>
                            </div>
                        </Card>
                    </Col>
                    <Col style={{marginLeft: 'auto', marginRight: 'auto'}} span={24}>
                        <Card bordered={false} style={{width: '100%'}}>
                            <div style={{padding: 12}}>
                                <Space direction='vertical' size={'middle'} style={{marginTop: 12}}>
                                    <Title level={4}>What domain do you want to connect to your showcase?</Title>
                                    <span>Enter the web address you want for your site. It can be a domain you want to buy or one you already own.</span>
                                    <Input addonBefore='https://'/>
                                    <Button className={'ant-btn-radius'} onClick={onConnectDomain}
                                            style={{marginLeft: 'auto', float: 'right'}}>
                                        Let&apos;s go
                                    </Button>
                                </Space>
                            </div>
                        </Card>
                    </Col>
                    {actionLayout()}
                    <Col style={{paddingTop: 48, marginRight: 'auto'}} span={24}>
                        <Collapse>
                            <Panel header={<Title level={4}>Frequently asked questions</Title>} key='1'>
                                {settingsFAQLayout()}
                            </Panel>
                        </Collapse>
                    </Col>
                </Row>
            )
        }

        const stepsPublishLayout = () => {
            return (
                <Row>
                    <Col style={{paddingTop: 48, marginLeft: 'auto', marginRight: 'auto'}}>
                        <Space direction={'vertical'} size={'large'}>
                            <p>Click publish to go live with your latest changes</p>
                            <Button
                                icon={<FileAddOutlined/>}
                                type={'primary'}
                                size='large'
                                onClick={onPublish}
                                style={{
                                    verticalAlign: 'middle',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    width: '100%'
                                }}
                            >
                                Publish
                            </Button>
                        </Space>
                    </Col>
                    {actionLayout()}
                </Row>
            )
        }

        const steps = [
            {
                title: 'Preview showcase',
                content: stepsPreviewLayout()
            },
            {
                title: 'Publish settings',
                content: stepsSettingsLayout()
            },
            {
                title: 'Confirm publish',
                content: stepsPublishLayout()
            }
        ]

        return (
            <Spin spinning={this.state.loading} size={'large'}>
                <div className='site-layout-background'>
                    <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}}>
                        <Col>
                            <Title style={{marginBottom: 0}}>Publish Your Showcase</Title>
                        </Col>
                    </Row>
                    <Divider/>
                    <div style={{padding: 12}}>
                        <Steps current={current} style={{padding: 12}}>
                            {steps.map((item) => (
                                <Step key={item.title} title={item.title}/>
                            ))}
                        </Steps>
                        <div style={{width: '100%'}}>{steps[this.state.current].content}</div>
                    </div>
                </div>
            </Spin>
        )
    }
}

export default withRouter(ShowcasePublish)
